import styles from "../styles/home.module.css";
import CardCarousel from "./SneakPeak";
import { Team } from "./Team";
import FAQs from "./Faqs";
import "react-html5video/dist/styles.css";
import homepagemain from "./main.png";

function Home() {
  return (
    <>
      <div className={styles.home}>
        <div className={styles.mainSection}>
          <div className={styles.homeleft}>
            <h1 className={styles.ilpheading}>
              Industrial <br /> Learning <br /> Program
            </h1>
          </div>

          <div className={styles.homeright}>
            <img src={homepagemain} alt="" />
          </div>
        </div>

        {localStorage.getItem("accessToken") === null && (
          <div
            style={{
              width: "100vw",
              display: "flex",
              justifyContent: "center",
              marginTop: "-5vh",
            }}
          >
            <a href="/register" style={{ textDecoration: "none" }}>
              <button className={styles.homeRegisterButton}>
                Register
              </button>
            </a>
          </div>
        )}

        <div className={styles.about}>
          <h1 className={styles.whatilp}>What is ILP</h1>
          <p>
            The Industrial Learning Program is one of the initiatives of the
            Student Alumni Relations Cell aimed at providing the students with
            opportunities to use their academic expertise in solving real life
            problems offered by the distinguished IIT-B Alumni. This year ILP
            brings 15+ Projects in its Summer Iteration. This is a unique
            opportunity for students to get real industrial exposure in several
            core and non core fields. Alumni from various sectors float
            projects/problems to be solved by the students with their knowledge
            and expertise. The selected students get rewarded by the alumni via
            certificates and stipend for the summer internships provided.
          </p>

          <div className={styles.ruleBookSection}>
            <div className={styles.ruleBookContent}>
              <div className={styles.ruleBookHeader}>
                <span className={styles.ruleBookIcon}>📋</span>
                <span>ILP RuleBook</span>
              </div>
              <p className={styles.ruleBookText}>
                Here is the rule book which includes the procedure for signing up for the program and the rewards/penalties.
              </p>
              <a 
                href="https://docs.google.com/document/d/1F0h9od12GDUPq8xiRgLYOz25TyA0BVRBt-qFR5UtrOc/edit?tab=t.0"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.ruleBookButton}
              >
                View RuleBook
              </a>
            </div>
          </div>
        </div>

        <div id="faqs" className={styles.Faqs}>
          <FAQs />
        </div>

        <div id="team" className={styles.team}>
          <Team />
        </div>
      </div>
    </>
  );
}

export default Home;